import {
  getEventActionName,
  getFailActionName,
  getSuccessActionName,
} from "../../core/make-action";
import ViewerEvent from "../../core/ViewerEvent";
import { combineReducers } from "redux";
import { makeEventReducer } from "../../core/make-reducer";
import ViewerMethod from "../../core/ViewerMethod";
import loadStatus from "./load-status/reducer";

function pageScroll(state = {}, action) {
  switch (action.type) {
    case getEventActionName(ViewerEvent.PAGE_SCROLL):
      return action.eventData;
    case getEventActionName(ViewerEvent.PAGE_READY):
      // Clear when we get new page info so it stays well-synced
      return {};
    default:
      return state;
  }
}

function universalUrl(state = "", action) {
  switch (action.type) {
    case getSuccessActionName(ViewerMethod.GET_UNIVERSAL_URL):
      return action.resultData.url;
    case getFailActionName(ViewerMethod.GET_UNIVERSAL_URL):
      return "";
    case getEventActionName(ViewerEvent.NAVIGATION_REQUESTED):
      return "";
    default:
      return state;
  }
}

function hasNextContentDoc(state = false, action) {
  switch (action.type) {
    case getSuccessActionName(ViewerMethod.HAS_NEXT_CONTENT_DOC):
      return action.resultData;
    default:
      return state;
  }
}

function hasPreviousContentDoc(state = false, action) {
  switch (action.type) {
    case getSuccessActionName(ViewerMethod.HAS_PREVIOUS_CONTENT_DOC):
      return action.resultData;
    default:
      return state;
  }
}

function pageHasScrolled(
  state = { shouldWatch: false, hasScrolled: false },
  action
) {
  switch (action.type) {
    case getEventActionName(ViewerEvent.NAVIGATION_REQUESTED):
      return {
        shouldWatch: false,
        hasScrolled: false,
      };
    case getEventActionName(ViewerEvent.PAGE_READY):
      return {
        shouldWatch: true,
        hasScrolled: false,
      };
    case getEventActionName(ViewerEvent.PAGE_SCROLL):
      if (state.shouldWatch) {
        return { shouldWatch: false, hasScrolled: true };
      }
      return state;
    default:
      return state;
  }
}

export default combineReducers({
  pageBreak: makeEventReducer(ViewerEvent.BOOK_PAGEBREAK),
  pageScroll,
  universalUrl,
  hasNextContentDoc,
  hasPreviousContentDoc,
  pageHasScrolled,
  loadStatus,
});
